import React from "react";

const HeroSection = ({ formData, handleChange, handleInitialSubmit, isSubmitted }) => {
  return (
    <section className="relative px-4 py-16 md:py-24 mt-16">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-4xl md:text-7xl font-bold mb-6">
          The Modern, Unified
          <br />
          <span className="text-[hsl(30,100%,85%)] italic">E-Commerce Platform</span>
          <br />
          <span className="text-md text-gray-400 italic">for businesses selling online</span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
          30+% cheaper than platform + apps. 10x easier to use. AI automations and workflows.
        </p>
        <p className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto">
          The unified platform that replaces traditional platforms, subscription apps, bundling apps, review collection apps, affiliate program apps, email marketing apps, and more - with one unified solution. <span className="text-[hsl(30,100%,85%)] font-semibold">No apps needed.</span>
        </p>
        
        <form
          onSubmit={handleInitialSubmit}
          className="flex flex-col md:flex-row gap-4 justify-center max-w-lg mx-auto mb-8"
        >
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
            className="flex-1 px-6 py-4 text-base bg-gray-800/50 backdrop-blur-sm border border-gray-600/50 rounded-full text-white focus:outline-none focus:ring-2 focus:ring-[hsl(30,100%,85%)]/50 transition-all duration-300"
          />
          <button
            type="submit"
            disabled={isSubmitted}
            className="bg-[hsl(30,100%,85%)] text-black px-8 py-4 rounded-full text-base font-medium hover:bg-white transition-all duration-300 hover:scale-105 active:scale-95 disabled:opacity-50"
          >
            {isSubmitted ? "Thanks! We'll be in touch 🎉" : "Book Your Demo"}
          </button>
        </form>
        
        <p className="text-sm text-gray-500">Free audit of your current tech-stack + site set-up and admin access for free!</p>
      </div>
    </section>
  );
};

export default HeroSection; 